"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _mobxReact = require("mobx-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ravenJs = _interopRequireDefault(require("raven-js"));
var _react = _interopRequireWildcard(require("react"));
var _invoke = _interopRequireDefault(require("lodash/invoke"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _GradientAnimation = _interopRequireDefault(require("../GradientAnimation"));
var _browserUtils = require("../../utils/browser-utils");
var _styles = require("./styles");
var _Overlay = _interopRequireDefault(require("../Overlay"));
var _constants = require("./constants");
var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _PictureComponent; //lodash
//helpers
//styled components
//constants
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var PictureComponent = (0, _mobxReact.observer)(_class = (_class2 = (_PictureComponent = /*#__PURE__*/function (_Component) {
  function PictureComponent(props) {
    var _this;
    _classCallCheck(this, PictureComponent);
    _this = _callSuper(this, PictureComponent, [props]);
    _initializerDefineProperty(_this, "legacySrc", _descriptor, _this);
    _initializerDefineProperty(_this, "naturalAspectRatio", _descriptor2, _this);
    _initializerDefineProperty(_this, "status", _descriptor3, _this);
    _defineProperty(_this, "imageElement", null);
    _defineProperty(_this, "useLegacy", !(0, _browserUtils.isObjectFitSupported)() || (0, _browserUtils.isEdge)() || (0, _browserUtils.isIE)());
    _defineProperty(_this, "setImageElement", function (value) {
      _this.imageElement = value;
    });
    _initializerDefineProperty(_this, "setLegacySrc", _descriptor4, _this);
    _initializerDefineProperty(_this, "setNaturalAspectRatio", _descriptor5, _this);
    _initializerDefineProperty(_this, "setStatus", _descriptor6, _this);
    _defineProperty(_this, "handleImageError", function () {
      _ravenJs["default"].captureException(new Error('Image failed to load'), {
        extra: {
          imageSrc: _this.props.src
        }
      });
      _this.markAsFailed();
    });
    _defineProperty(_this, "handleImageLoad", function (event) {
      _this.setNaturalAspectRatio(_this.imageElement.naturalWidth / _this.imageElement.naturalHeight);
      _this.markAsReady();
      (0, _invoke["default"])(_this.props, 'onLoad', event);
    });
    _defineProperty(_this, "markAsEmpty", function () {
      _this.setLegacySrc(null);
      _this.setStatus(_constants.PICTURE_STATUS.EMPTY);
    });
    _defineProperty(_this, "markAsFailed", function () {
      _this.setLegacySrc(null);
      _this.setStatus(_constants.PICTURE_STATUS.FAILED);
    });
    _defineProperty(_this, "markAsLoading", function () {
      _this.setLegacySrc(null);
      _this.setStatus(_constants.PICTURE_STATUS.LOADING);
    });
    _defineProperty(_this, "markAsReady", function () {
      var currentSrc = _this.imageElement.currentSrc || _this.imageElement.src;
      _this.setLegacySrc(currentSrc);
      _this.setStatus(_constants.PICTURE_STATUS.READY);
    });
    _defineProperty(_this, "restartAnimation", function () {
      if (!_this.imageElement || !_this.isReady) {
        return;
      }
      if (_this.useLegacy) {
        // NB. This is mainly for Internet Explorer. While appending
        // the URL with a cachebuster is enough for it to restart
        // the animation, it would still be showing the current animation
        // until the "new" file loads. To avoid that, we are removing
        // the current background and assigning a new one only in the
        // next animation frame.

        var currentSrc = _this.imageElement.currentSrc || _this.imageElement.src;
        var separator = currentSrc.includes('?') ? '&' : '?';
        var cachebuster = "restart=".concat(Date.now().toString(16));
        _this.setLegacySrc(null);
        window.requestAnimationFrame(function () {
          _this.setLegacySrc("".concat(currentSrc).concat(separator).concat(cachebuster));
        });
      } else {
        // NB. Normally, you would only require to reset src / srcset
        // to the value they've already had. However, this doesn't work
        // in Firefox -- it requires the attributes to be removed first
        // and then restored in the next animation frame.

        var _this$imageElement = _this.imageElement,
          src = _this$imageElement.src,
          srcset = _this$imageElement.srcset;
        _this.imageElement.removeAttribute('src');
        _this.imageElement.removeAttribute('srcset');
        window.requestAnimationFrame(function () {
          _this.imageElement.src = src;
          _this.imageElement.srcset = srcset;
        });
      }
    });
    (0, _mobx.makeObservable)(_this);
    return _this;
  }
  _inherits(PictureComponent, _Component);
  return _createClass(PictureComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        src = _this$props.src,
        srcSet = _this$props.srcSet;
      if (src || srcSet) {
        this.markAsLoading();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        restartAnimation = _this$props2.restartAnimation,
        src = _this$props2.src,
        srcSet = _this$props2.srcSet;
      if (prevProps.restartAnimation !== restartAnimation) {
        this.restartAnimation();
      }
      if (prevProps.src !== src || prevProps.srcSet !== srcSet) {
        if (src || srcSet) {
          this.markAsLoading();
        } else {
          this.markAsEmpty();
        }
      }
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.status === _constants.PICTURE_STATUS.EMPTY;
    }
  }, {
    key: "isFailed",
    get: function get() {
      return this.status === _constants.PICTURE_STATUS.FAILED;
    }
  }, {
    key: "isLoading",
    get: function get() {
      return this.status === _constants.PICTURE_STATUS.LOADING;
    }
  }, {
    key: "isReady",
    get: function get() {
      return this.status === _constants.PICTURE_STATUS.READY;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        backgroundColor = _this$props3.backgroundColor,
        emptyIcon = _this$props3.emptyIcon,
        metadata = _this$props3.metadata,
        objectFit = _this$props3.objectFit,
        objectPositionX = _this$props3.objectPositionX,
        objectPositionY = _this$props3.objectPositionY,
        shouldShowSpinnerWhileLoading = _this$props3.shouldShowSpinnerWhileLoading,
        shouldShowAnimationWhileLoading = _this$props3.shouldShowAnimationWhileLoading,
        shouldShowOverlayShapes = _this$props3.shouldShowOverlayShapes,
        overlayShapes = _this$props3.overlayShapes,
        sizes = _this$props3.sizes,
        src = _this$props3.src,
        srcSet = _this$props3.srcSet;
      var baseImageProps = {
        isTransparent: !this.isReady,
        objectFit: objectFit,
        objectPositionX: objectPositionX,
        objectPositionY: objectPositionY
      };
      var forwardedProps = (0, _omit["default"])(this.props, Object.keys(PictureComponent.propTypes));
      return /*#__PURE__*/_react["default"].createElement(_styles.Picture, _extends({
        backgroundColor: backgroundColor
      }, forwardedProps), this.isLoading && shouldShowAnimationWhileLoading && /*#__PURE__*/_react["default"].createElement(_GradientAnimation["default"], null), !this.isEmpty && /*#__PURE__*/_react["default"].createElement(_styles.StyledImage, _extends({
        ref: this.setImageElement,
        isHidden: this.useLegacy,
        onError: this.handleImageError,
        onLoad: this.handleImageLoad,
        sizes: sizes,
        src: src,
        srcSet: srcSet
      }, baseImageProps)), this.useLegacy && /*#__PURE__*/_react["default"].createElement(_styles.LegacyImage, _extends({
        src: this.legacySrc
      }, baseImageProps)), this.isEmpty && emptyIcon, this.isFailed && /*#__PURE__*/_react["default"].createElement(_styles.StyledIcon, {
        name: "image-broken"
      }), this.isLoading && shouldShowSpinnerWhileLoading && /*#__PURE__*/_react["default"].createElement(_styles.StyledSpinner, null), shouldShowOverlayShapes && !this.isLoading && /*#__PURE__*/_react["default"].createElement(_Overlay["default"], {
        imageAspectRatio: this.naturalAspectRatio,
        imageFit: objectFit,
        imageMetadata: metadata,
        imageObjectPositionX: objectPositionX,
        imageObjectPositionY: objectPositionY,
        overlayShapes: overlayShapes,
        shouldShowOverlayShapes: shouldShowOverlayShapes
      }));
    }
  }]);
}(_react.Component), _defineProperty(_PictureComponent, "defaultProps", {
  backgroundColor: 'rgba(0, 0, 0, 0.05)',
  emptyIcon: /*#__PURE__*/_react["default"].createElement(_styles.StyledIcon, {
    name: "image"
  }),
  objectFit: 'cover',
  objectPositionX: 0.5,
  objectPositionY: 0.5,
  shouldShowSpinnerWhileLoading: false,
  shouldShowOverlayShapes: false,
  overlayShapes: []
}), _defineProperty(_PictureComponent, "propTypes", {
  backgroundColor: _propTypes["default"].string,
  emptyIcon: _propTypes["default"].node,
  objectFit: _propTypes["default"].oneOf(['contain', 'cover']),
  objectPositionX: _propTypes["default"].number,
  objectPositionY: _propTypes["default"].number,
  onLoad: _propTypes["default"].func,
  restartAnimation: _propTypes["default"].bool,
  shouldShowSpinnerWhileLoading: _propTypes["default"].bool,
  shouldShowOverlayShapes: _propTypes["default"].bool,
  overlayShapes: _propTypes["default"].array,
  sizes: _propTypes["default"].string,
  src: _propTypes["default"].string,
  srcSet: _propTypes["default"].string
}), _PictureComponent), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "legacySrc", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "naturalAspectRatio", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "status", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants.PICTURE_STATUS.EMPTY;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "isEmpty", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isEmpty"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isFailed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isFailed"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isLoading", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isLoading"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isReady", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isReady"), _class2.prototype), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "setLegacySrc", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;
    return function (value) {
      _this2.legacySrc = value;
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "setNaturalAspectRatio", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function (naturalAspectRatio) {
      _this3.naturalAspectRatio = naturalAspectRatio;
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "setStatus", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function (value) {
      _this4.status = value;
    };
  }
})), _class2)) || _class;
var _default = exports["default"] = PictureComponent;
//# sourceMappingURL=index.js.map